import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import InvoiceService from '../../../../../services/api/invoice.service'
import DimLoader from '../../../../templates/components/DimLoader'
import APIResponse from '../../../../templates/components/APIResponse'

const CloseAndWriteOff = (props) => {

    const [closeReason, setCloseReason] = useState(props.closeReason ? props.closeReason : '')
    const [errors, setErrors] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const cancelWOHandler = () => {
        let reqObj = { closeReason: closeReason }
        if (closeReason?.length >= 10) {
            setIsLoader(true)
            InvoiceService.closeAndWriteOff(props.invoiceId, reqObj)
                .then(res => {
                    setApiResponse(res)
                }).catch(err => {
                    setApiResponse(err)
                }).finally(() => {
                    setIsLoader(false)
                });
        }
        else {
            toast.error("Your reason for closing must be more than 10 characters")
        }
    }
    useEffect(() => {
        if (closeReason?.length < 10) {
            setErrors("Your reason for closing must be more than 10 characters")
        }
        else if (!closeReason || closeReason == "") {
            setErrors("A reason for closing this invoice is required")
        }
        else {
            setErrors()
        }
    })
    return (
        <>
        {isLoader &&
            <DimLoader loadMessage="Processing..." />}
        <div className='w-100 row d-flex'>
                <div className='col-12'>
                    <div className=" card p-3 bg-faded text-primary b-1">
                        {props.closeReason ? (
                            "Are you sure you want to close this invoice?"
                        ) : (
                            "Are you sure you would like to remove the patient balance and write it off? Please provide a reason why."
                        )}
                    </div>
                </div>
                {!props.closeReason && (
                    <div className='field required col-12'>
                        <label>Reason</label>
                        <input type="text" className="mt-3" minLength={10} value={closeReason} onChange={e => { e.preventDefault(); setCloseReason(e.target.value); }} />
                        <span className='error-message'>{errors && errors}</span>
                    </div>
                )}
            <div className='col-12 mt-3 d-flex justify-content-between'>
                <div className='col-auto'>
                    <button className="btn btn-primary" onClick={e => { e.preventDefault(); cancelWOHandler() }}>Yes</button>
                </div>
                <div className='col-auto'>
                    <button className="btn btn-secondary float-right" onClick={e => { e.preventDefault(); if (props.onClose()) { props.onClose() } }}>No</button>
                </div>
            </div>
        </div>
        <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default CloseAndWriteOff